export default "__VITE_ASSET__B$AR1C1L__"